import { DRUPAL_NODE_DISPLAY, type DrupalImage, type DrupalNodePage } from '@commons/types/drupal';

import CampaignPageNodeCard from './Card';
import CampaignPageNodeLabel from './Label';
import CampaignPageNodeTile from './Tile';

/**
 * Type definition of a CampaignPage node properties.
 */

export type CampaignPageNodeProps = DrupalNodePage & {
  image?: DrupalImage;
  summary?: string;
};

/**
 * CampaignPage node component.
 *
 * Renders a component based on the display type.
 */

export const CampaignPageNode = (props: CampaignPageNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <CampaignPageNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <CampaignPageNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Tile:
      return <CampaignPageNodeTile {...props} />;
  }
};

export default CampaignPageNode;
